/**
 * UniKnKubusPage React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import Paper from '@material-ui/core/Paper';

// application
import ObjectFieldSet from '../../editing/ObjectFieldSet';


const previewFactor = 1.0 / 3.0;

const boxNames = ['kubus1', 'kubus2', 'kubus3'];

const commandFields = [
    {
        "id": "triggersensorcommand",
        "name": "Sensorbereich betreten",
        "type": "command",
        "resturl": "/presentation/navigate?boxname=<boxname>&level1=1",
        "restmethod": "GET"
    },
    {
        "id": "untriggersensorcommand",
        "name": "Sensorbereich verlassen",
        "type": "command",
        "resturl": "/presentation/navigate?boxname=<boxname>&level1=0",
        "restmethod": "GET"
    },
    {
        "id": "reloadcommand",
        "name": "Reload",
        "type": "command",
        "resturl": "/box/reload?boxname=<boxname>",
        "restmethod": "GET"
    }
];


/**
 * UniKnKubusPage is a customer page
 */
function UniKnKubusPage(props) {

    const { classes } = props;

    return <Paper>
        <div className={classes.root}>
            {
                boxNames.map(boxName => <div key={boxName} className={classes.boxPanel}>
                    <div className={classes.commandPanel}>
                        <ObjectFieldSet
                            fieldDefinitions={
                                commandFields.map(field => (
                                    {
                                        ...field,
                                        resturl: field.resturl.replace('<boxname>', boxName)
                                    }
                                ))
                            }
                            objectId={null}
                            objectFields={{}}
                            readOnly={true}
                            scope={[]}
                            onObjectValueChange={value => {}}
                        />
                    </div>
                    <div className={classes.iframeContainer}>
                        <div style={{transform: "scale(" + previewFactor + ")", transformOrigin: "0 0"}}>
                            <iframe title={boxName}
                                className={classes.iframeElement}
                                src={'/?cbox=' + boxName}
                                referrerPolicy="no-referrer"
                            />
                        </div>
                    </div>
                </div>)
            }
        </div>
    </Paper>;
}


const styles = theme => ({
    root: {
        padding: theme.spacing.unit,
        display: "flex",
        flexDirection: "row"
    },
    boxPanel: {
    },
    iframeContainer: {
        margin: 2,
        width: 1080 * previewFactor,
        height: 2 * 1920 * previewFactor
    },
    iframeElement: {
        width: 1080,
        height: 2 * 1920,
        borderStyle: "none"
    },
    commandPanel: {
        width: 1080 * previewFactor,
        whiteSpace: "normal",
        marginBottom: 12
    }
});


export default withStyles(styles)(UniKnKubusPage);
